import { Component, Input } from '@angular/core';
import { ProductCardComponent } from '../product-card/product-card.component';
import { ProductCardStackComponent } from '../product-card-stack/product-card-stack.component';
import { ShopifyStorefrontService } from '../../services/shopify-storefront.service';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-product-list',
  imports: [ProductCardComponent, ProductCardStackComponent, CommonModule],
  templateUrl: './product-list.component.html',
  styleUrl: './product-list.component.scss'
})
export class ProductListComponent {
  @Input('handle') handle!: string;
  constructor(
    private data: ShopifyStorefrontService,
     private sanitizer: DomSanitizer
  ) { }

  get products() {
    return this.data.getCachedProductsByCollectionHandle(this.handle);
  }

  get schemaMarkup(): SafeHtml | null {
    const products = this.products;
    if (!products?.length) return null;

    const items = products.map((product: any) => ({
      "@type": "Product",
      "name": product.title,
      "image": product.featuredImage?.url,
      "description": product.description,
      "sku": product.style_name.value,
      "offers": {
        "@type": "Offer",
        "priceCurrency": product.priceRange?.maxVariantPrice?.currencyCode,
        "price": product.priceRange?.maxVariantPrice?.amount,
        "availability": "https://schema.org/InStock"
      }
    }));

    const schema = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      "itemListElement": items.map((item, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "item": item
      }))
    };

    const scriptTag = `<script type="application/ld+json">${JSON.stringify(schema)}</script>`;
    return this.sanitizer.bypassSecurityTrustHtml(scriptTag);
  }
}
